<template>
  <div>
    <!-- <el-card style="position: relative">
      <p class="title_p">原有指令下发</p>
      <el-button
        type="primary"
        class="btn_position"
        size="mini"
        @click="deliveryDialogOpen()"
        >打 开</el-button
      >
    </el-card> -->
    <el-card style="position: relative">
      <p class="title_p">基本配置</p>
      <el-button
        type="primary"
        class="edit_position"
        @click="basicConfigFlag = !basicConfigFlag"
        size="mini"
        >编 辑</el-button
      >
      <el-button
        type="primary"
        class="btn_position"
        :disabled="basicConfigFlag"
        @click="basicConfigs()"
        size="mini"
        >下 发</el-button
      >
      <el-form class="basic_config">
        <el-form-item label="电站最大功率：" label-width="200px">
          <el-input
            :disabled="basicConfigFlag"
            v-model="basicConfig.maxChargePower"
            style="width: 200px"
          ></el-input>
          KW
        </el-form-item>
        <el-form-item label="电容：" label-width="200px">
          <el-input
            :disabled="basicConfigFlag"
            v-model="basicConfig.tolerancePower"
            style="width: 200px"
          ></el-input>
          KW
        </el-form-item>
        <el-form-item label="电芯最高电压：" label-width="200px">
          <el-input
            :disabled="basicConfigFlag"
            v-model="basicConfig.bmsMaxSingleVoltageLimit"
            style="width: 200px"
          ></el-input>
          mv
        </el-form-item>
        <el-form-item label="电芯最低电压：" label-width="200px">
          <el-input
            :disabled="basicConfigFlag"
            v-model="basicConfig.bmsMinSingleVoltageLimit"
            style="width: 200px"
          ></el-input>
          mv
        </el-form-item>
        <el-form-item label="电芯最高温度：" label-width="200px">
          <el-input
            :disabled="basicConfigFlag"
            v-model="basicConfig.bmsMaxTemp"
            style="width: 200px"
          ></el-input>
          °C
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="position: relative">
      <p class="title_p">空调配置</p>
      <el-button
        type="primary"
        class="edit_position"
        @click="airConfigFlag = !airConfigFlag"
        size="mini"
        >编 辑</el-button
      >
      <el-button
        type="primary"
        class="btn_position"
        :disabled="airConfigFlag"
        @click="airConfigs()"
        size="mini"
        >下 发</el-button
      >
      <el-form class="basic_config">
        <el-form-item label="最高室温阈值：" label-width="200px">
          <el-input
            :disabled="airConfigFlag"
            v-model="airCond.maxTempLimit"
            style="width: 200px"
          ></el-input>
          °C
        </el-form-item>
        <el-form-item label="室温关机阈值：" label-width="200px">
          <el-input
            :disabled="airConfigFlag"
            v-model="airCond.tempThreshold"
            style="width: 200px"
          ></el-input>
          °C
        </el-form-item>
        <el-form-item label="达到高温，空调温度设为：" label-width="200px">
          <el-input
            :disabled="airConfigFlag"
            v-model="airCond.tempWhileTempLmitReached"
            style="width: 200px"
          ></el-input>
          °C
        </el-form-item>
        <el-form-item label="单体电芯温度：" label-width="200px">
          <el-input
            :disabled="airConfigFlag"
            v-model="airCond.maxSingleBatteryTempLimit"
            style="width: 200px"
          ></el-input>
          °C
        </el-form-item>
        <el-form-item label="电池堆温度阈值：" label-width="200px">
          <el-input
            :disabled="airConfigFlag"
            v-model="airCond.batteryTempThreshold"
            style="width: 200px"
          ></el-input>
          °C
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="position: relative">
      <p class="title_p">PCS配置</p>
      <el-button
        type="primary"
        class="edit_position"
        @click="pcsConfigFlag = !pcsConfigFlag"
        size="mini"
        >编 辑</el-button
      >
      <el-button
        type="primary"
        class="btn_position"
        :disabled="pcsConfigFlag"
        @click="pcsConfigs()"
        size="mini"
        >下 发</el-button
      >
      <el-form class="basic_config">
        <el-form-item label="pcs No：" label-width="200px">
          <el-select v-model="pcsNo" @change="selectChage()">
            <el-option
              v-for="(item, index) in pcsConfigList"
              :key="index"
              :label="item.pcsNo"
              :value="item.pcsNo"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电池过压保护点：" label-width="200px">
          <el-input
            :disabled="pcsConfigFlag"
            v-model="pcsConfig.batteryOvervoltageProtectionPoint"
            style="width: 200px"
          ></el-input>
          V
        </el-form-item>
        <el-form-item label="电池欠压保护点：" label-width="200px">
          <el-input
            :disabled="pcsConfigFlag"
            v-model="pcsConfig.batteryUndervoltageProtectionPoint"
            style="width: 200px"
          ></el-input>
          V
        </el-form-item>
        <el-form-item label="EMS通讯故障：" label-width="200px">
          <el-input
            :disabled="pcsConfigFlag"
            v-model="pcsConfig.emsCommThreshold"
            style="width: 200px"
          ></el-input>
          S
        </el-form-item>
        <el-form-item label="ReModdbus地址：" label-width="200px">
          <el-input
            :disabled="pcsConfigFlag"
            v-model="pcsConfig.reModbusAddress"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="ReModdbus波特率：" label-width="200px">
          <el-input
            :disabled="pcsConfigFlag"
            v-model="pcsConfig.reModbusBaud"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="HMI Moddbus地址：" label-width="200px">
          <el-input
            :disabled="pcsConfigFlag"
            v-model="pcsConfig.hmiModbusAddress"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="HMI Moddbus波特率：" label-width="200px">
          <el-input
            :disabled="pcsConfigFlag"
            v-model="pcsConfig.hmiModbusBaud"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <el-dialog
      title=""
      :visible.sync="showDeliveryDialog"
      style="text-align: left"
    >
      <div class="content-box side">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <i class="iconfont icon-setting-full"></i>
            <span>操作设备 </span>
          </div>
          <el-form label-width="100px">
            <el-form-item label="设备编号">
              <b>{{ cabinetCode }}</b>
            </el-form-item>
            <el-form-item label="设备状态">
              <el-select
                placeholder="请选择..."
                v-model="workStateControl.state"
                style="width: 120px"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.Name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="setWorkState"
                >下发</el-button
              >
            </el-form-item>

            <el-form-item label="设备密码">
              <el-select
                placeholder="请选择..."
                v-model="cabinetPasswd.userType"
                style="width: 120px"
              >
                <el-option
                  v-for="item in userTypeList"
                  :key="item.userType"
                  :label="item.Name"
                  :value="item.userType"
                >
                </el-option>
              </el-select>
              <el-button plain icon="el-icon-view" @click="showPasswd"
                >指令查询</el-button
              >
              <span class="interval-box"> {{ cabinetPasswd.oldPasswd }} </span>
              <el-input
                v-model="cabinetPasswd.newPasswd"
                style="width: 150px"
                placeholder="8位数字密码"
              >
              </el-input>
              <el-button type="primary" icon="el-icon-edit" @click="setPasswd"
                >下发</el-button
              >
            </el-form-item>
            <el-form-item label="设备费率">
              <el-button plain icon="el-icon-view" @click="showFeeConfig"
                >指令查询</el-button
              >
              <span class="interval-box"></span>
              <el-select
                placeholder="请选择..."
                v-model="delivery.feeConfigId"
                style="width: 150px; margin-right: 35px"
              >
                <el-option
                  v-for="item in FeeConfigList"
                  :key="item.id"
                  :label="item.feeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <div v-if="false">
                生效时间：
                <el-date-picker
                  style="width: 180px"
                  v-model="delivery.effectiveTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="生效时间"
                >
                </el-date-picker>
              </div>
              <div v-if="false">
                尖峰月：
                <el-input
                  style="width: 100px"
                  v-model="delivery.topPeakMonths"
                  placeholder="6,7,8"
                ></el-input>
              </div>
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="setFeeConfig"
                >下发</el-button
              >
            </el-form-item>
            <el-form-item label="软件升级">
              <el-input
                v-model="cabinetUpdate.softVer"
                style="width: 150px; margin-right: 38px"
                placeholder="版本号,如：1.002"
              >
              </el-input>
              <div v-if="false">
                下载地址：
                <el-input
                  v-model="cabinetUpdate.downUrl"
                  style="width: 442px"
                  placeholder="完整URL http://..."
                />
              </div>
              <el-button type="primary" icon="el-icon-edit" @click="setUpdate"
                >下发</el-button
              >
            </el-form-item>
          </el-form>
          <el-row class="card-form" v-show="showFee">
            <el-col :xs="24" :sm="12">
              <el-card shadow="hover">
                <div slot="header" class="clearfix">
                  <span>时段/充电最大功率</span>
                </div>
                <div class="dl-box">
                  <ul>
                    <li
                      style="margin-bottom: 12px"
                      v-for="(fee, index) in feeModel.periodFeeConfigs"
                      :key="index"
                    >
                      {{ fee.startTime }}
                      <span style="margin: 0 10px 22px">至</span>
                      {{ fee.endTime }}
                      <span style="margin: 0 10px 22px"></span>
                      <span v-if="fee.controlMode == 1">充电</span>
                      <span v-else-if="fee.controlMode == 2">放电</span>
                      <span v-else="fee.controlMode == 3">空闲</span>
                      <span v-if="fee.periodType == 1">尖</span>
                      <span v-else-if="fee.periodType == 2">峰</span>
                      <span v-else-if="fee.periodType == 3">平</span>
                      <span v-else-if="fee.periodType == 4">谷</span>
                      <span v-else="fee.periodType == 5">高尖</span>
                      <span style="margin-left: 10px">{{ fee.maxPower }}</span>
                      <span>kW</span>
                    </li>
                  </ul>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-card shadow="hover">
                <div slot="header" class="clearfix">
                  <span>费用</span>
                </div>
                <div class="dl-box-fee">
                  <div>尖时:{{ feeModel.fee1 }} 元</div>
                  <div>峰时:{{ feeModel.fee2 }} 元</div>
                  <div>平时:{{ feeModel.fee3 }} 元</div>
                  <div>谷时:{{ feeModel.fee4 }} 元</div>
                  <div>高尖时:{{ feeModel.fee5 }} 元</div>
                </div>
              </el-card>
              <el-card shadow="hover" style="margin: 20px 0px 0px 0px">
                <div slot="header" class="clearfix">
                  <span>其他</span>
                </div>
                <div class="dl-box">
                  <ul>
                    <li style="margin-bottom: 12px">
                      生效时间： <span style="margin: 0 10px 22px"></span>
                      {{ feeModel.effectiveTime }}
                    </li>
                    <li style="margin-bottom: 12px; display: none">
                      尖峰月： <span style="margin: 0 10px 22px"></span>
                      <span
                        v-for="(mon, index) in feeModel.topPeakMonths"
                        style="margin: 0 10px 0px 0px"
                        :key="index"
                        >{{ mon }}</span
                      >
                    </li>
                  </ul>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      basicConfigFlag: true,
      airConfigFlag: true,
      pcsConfigFlag: true,
      airCond: {
        // 空调
        cabinetCodes: [],
        maxTempLimit: "",
        tempThreshold: "",
        tempWhileTempLmitReached: "",
        maxSingleBatteryTempLimit: "",
        batteryTempThreshold: "",
      },
      basicConfig: {
        // 基础
        cabinetCodes: [],
        maxChargePower: "",
        tolerancePower: "",
        bmsMaxSingleVoltageLimit: "",
        bmsMinSingleVoltageLimit: "",
        bmsMaxTemp: "",
      },
      pcsConfig: {
        // pcs
        cabinetCodes: [],
        batteryOvervoltageProtectionPoint: "",
        batteryUndervoltageProtectionPoint: "",
        emsCommThreshold: "",
        reModbusAddress: "",
        reModbusBaud: "",
        hmiModbusAddress: "",
        hmiModbusBaud: "",
        pcsNo: "",
      },
      pcsNo: "",
      pcsConfigList: [],
      showDeliveryDialog: false,
      cabinetCode: "",
      FeeConfigList: [],
      showFee: false, //显示查询结果
      stateList: [
        {
          Name: "停机",
          id: 2,
        },
        {
          Name: "运行",
          id: 6,
        },
      ],
      userTypeList: [
        {
          Name: "技术员",
          userType: "admin",
        },
        {
          Name: "运营商",
          userType: "customer",
        },
      ],
      delivery: {
        effectiveTime: "",
        topPeakMonths: "",
        feeConfigId: "",
      },
      cabinetPasswd: {
        userType: "customer",
        cabinetCode: "",
        newPasswd: "",
        oldPasswd: "******",
      },
      cabinetUpdate: {
        cabinetCode: "",
        softVer: "",
        downUrl: "",
        force: "",
        md5: "",
      },
      workStateControl: {
        cabinetCode: "",
        state: "",
      },
      feeModel: {
        effectiveTime: "",
        fee1: 0,
        fee2: 0,
        fee3: 0,
        fee4: 0,
        fee5: 0,
        periodFeeConfigs: [
          {
            controlMode: 0,
            endTime: "",
            periodType: 0,
            startTime: "",
          },
        ],
        topPeakMonths: [],
      },
    };
  },
  mounted() {
    const _this = this;
    this.id = this.$route.query.id || "";
    this.companyId = this.$route.query.companyId || "";
    this.cabinetCode = this.$route.query.cabinetCodes || "";
    this.airCond.cabinetCodes.push(this.$route.query.cabinetCodes || "");
    this.basicConfig.cabinetCodes.push(this.$route.query.cabinetCodes || "");
    this.pcsConfig.cabinetCodes.push(this.$route.query.cabinetCodes || "");
    AxiosAjax({
      method: "post",
      url:
        "/cabinet/cabinet/airCondConfig/" +
        (this.$route.query.cabinetCodes || ""),
      success: function (res) {
        _this.airCond = res.data.data.data;
      },
    });
    AxiosAjax({
      method: "post",
      url:
        "/cabinet/cabinet/pcsConfig/" + (this.$route.query.cabinetCodes || ""),
      success: function (res) {
        res.data.data.data.forEach((element, i) => {
          if (element.pcsNo != 0) {
            _this.pcsConfigList.push(element);
          }
        });
        _this.pcsConfig = _this.pcsConfigList[0];
        _this.pcsNo = _this.pcsConfig.pcsNo;
      },
    });
    AxiosAjax({
      method: "post",
      url:
        "/cabinet/cabinet/cabinetConfig/" +
        (this.$route.query.cabinetCodes || ""),
      success: function (res) {
        _this.basicConfig = res.data.data.data;
      },
    });
  },
  methods: {
    //显示发指令窗口
    deliveryDialogOpen() {
      let _this = this;
      //加载费率列表
      AxiosAjax({
        url:
          "/cabinet/feeConfig/page?index=1&size=100&companyId=" +
          _this.companyId,
        success: function (res) {
          _this.FeeConfigList = res.data.data.content;
        },
      });
      _this.showDeliveryDialog = true;
    },
    setWorkState() {
      //设置费率
      let _this = this;
      var dataMode = {
        cabinetCode: _this.cabinetCode,
        state: _this.workStateControl.state,
      };
      //下发费率
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/workStateControl",
        data: dataMode,
        loading: true,
        success: function (res) {
          if (res.data.code == "000000") {
            _this.$message({
              type: "warning",
              message: res.data.data.msg,
            });
          }
        },
      });
    },
    showPasswd() {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //查询密码
      AxiosAjax({
        url:
          "/cabinet/cabinet/passwd/" +
          _this.cabinetCode +
          "?userType=" +
          _this.cabinetPasswd.userType,
        loading: true,
        success: function (res) {
          if (res.data.data.code == "000000") {
            _this.cabinetPasswd.oldPasswd = res.data.data.data;
          }
          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    setPasswd() {
      let _this = this;
      var _model = {
        cabinetCode: _this.cabinetCode,
        userType: _this.cabinetPasswd.userType,
        newPasswd: _this.cabinetPasswd.newPasswd,
        oldPasswd: "",
      };
      if (
        _this.cabinetPasswd.newPasswd.length > 20 ||
        _this.cabinetPasswd.newPasswd.length < 6
      ) {
        _this.$message({
          type: "warning",
          message: "6-20位数字字母密码",
        });
        return;
      }
      //设置密码
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/setPasswd",
        data: _model,
        loading: true,
        successMsg: "指令已发送",
        success: function (res) {
          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    showFeeConfig() {
      //查询费率
      let _this = this;
      _this.showFee = false;
      AxiosAjax({
        method: "get",
        url: "/cabinet/cabinet/feeConfig/" + _this.cabinetCode,
        loading: true,
        success: function (res) {
          if (res.data.data.code == "000000") {
            _this.showFee = true;
            _this.feeModel = res.data.data.data;
          }
          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    setFeeConfig() {
      //设置费率
      let _this = this;
      _this.showFee = false;
      var dataMode = {
        cabinetCodes: [_this.cabinetCode],
        effectiveTime: _this.delivery.effectiveTime,
        feeConfigId: _this.delivery.feeConfigId,
        topPeakMonths: [],
      };
      if (_this.delivery.topPeakMonths.length > 0) {
        dataMode.topPeakMonths = _this.delivery.topPeakMonths.split(",");
      }
      //下发费率
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/feeConfigIssue",
        data: dataMode,
        loading: true,
        success: function (res) {
          if (res.data.code == "000000") {
            console.log(res.data.data.msg);
            _this.$message({
              type: "warning",
              message: res.data.data.msg,
            });
          }
        },
      });
    },
    setUpdate() {
      let _this = this;
      _this.cabinetUpdate.downUrl =
        "http://ms.fuxinsz.com/Package/FuXinEnergy_" +
        _this.cabinetUpdate.softVer +
        ".zip";
      var _model = {
        cabinetCode: _this.cabinetCode,
        force: 0,
        downUrl: _this.cabinetUpdate.downUrl,
        softVer: _this.cabinetUpdate.softVer,
        md5: "",
      };
      if (_this.cabinetUpdate.softVer.length < 3) {
        _this.$message({
          type: "warning",
          message: "请输入版本号",
        });
        return;
      }
      if (_this.cabinetUpdate.downUrl.length < 10) {
        _this.$message({
          type: "warning",
          message: "下载地址不能为空",
        });
        return;
      }
      if (_this.cabinetUpdate.downUrl.indexOf("http") == -1) {
        _this.$message({
          type: "warning",
          message: "请输入正确的下载地址",
        });
        return;
      }
      //设置密码
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/updateSoft",
        data: _model,
        loading: true,
        successMsg: "指令已发送",
        success: function (res) {
          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    //显示发指令窗口
    deliveryDialogOpen() {
      let _this = this;
      //加载费率列表
      AxiosAjax({
        url:
          "/cabinet/feeConfig/page?index=1&size=100&companyId=" +
          _this.companyId,
        success: function (res) {
          _this.FeeConfigList = res.data.data.content;
        },
      });
      _this.showDeliveryDialog = true;
    },
    selectChage() {
      const _this = this;
      _this.pcsConfigList.map((res) => {
        if (res.pcsNo == _this.pcsNo) {
          _this.pcsConfig = res;
        }
      });
    },
    basicConfigs() {
      const _this = this;
      //基础下发
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/CabinetConfigIssue",
        data: _this.basicConfig,
        successMsg: "新增费率成功",
        success: function (res) {},
      });
    },
    airConfigs() {
      const _this = this;
      //空调下发
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/airCondConfigIssue",
        data: _this.airCond,
        successMsg: "新增费率成功",
        success: function (res) {},
      });
    },
    pcsConfigs() {
      const _this = this;
      //pcs下发
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/pcsConfigIssue",
        data: _this.pcsConfig,
        successMsg: "新增费率成功",
        success: function (res) {},
      });
    },
  },
};
</script>
<style scoped>
.title_p {
  text-align: left;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  padding-bottom: 16px;
  font-weight: 600;
}
.btn_position {
  position: absolute;
  top: 12px;
  right: 20px;
}
.edit_position {
  position: absolute;
  top: 12px;
  right: 120px;
}
.basic_config /deep/ .el-form-item__content {
  text-align: left;
}
.el-card {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/Distribute.vue